import React, { useMemo, useState } from "react";

// at top: just add the new prop
export default function AddGoalModal({ onClose, onSave, initialData }) {
  const [name, setName] = useState(initialData?.name ?? "");
  const [targetAmount, setTargetAmount] = useState(
    initialData?.targetAmount != null ? String(initialData.targetAmount) : ""
  );
  const [targetDate, setTargetDate] = useState(
    initialData?.targetDate || defaultYYYYMM(12)
  );
  const [priority, setPriority] = useState(initialData?.priority ?? 2);
  const [notes, setNotes] = useState(initialData?.notes ?? "");
  const [currentAmount, setCurrentAmount] = useState(
    initialData?.currentAmount != null ? String(initialData.currentAmount) : ""
  );

  const monthlySuggested = useMemo(() => {
    const t = Math.max(0, Number(targetAmount) || 0);
    const c = Math.max(0, Number(currentAmount) || 0);
    const net = Math.max(0, t - c);
    const months = Math.max(1, monthsUntil(targetDate));
    return Math.ceil(net / months);
  }, [targetAmount, currentAmount, targetDate]);

  return (
    <div style={backdropStyle}>
      <div style={modalStyle}>
        <h3 style={headerStyle}>Add Savings Goal</h3>

        <div style={row}>
          <label style={label}>Goal name</label>
          <input
            style={input}
            placeholder="Emergency fund, Vacation, Home updates…"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div style={row}>
          <label style={label}>Target amount ($)</label>
          <input
            type="number"
            style={input}
            placeholder="e.g. 3000"
            value={targetAmount}
            onChange={(e) => setTargetAmount(e.target.value)}
            min="0"
          />
        </div>

        <div style={row}>
          <label style={label}>Target date</label>
          <input
            type="month"
            style={input}
            value={targetDate}
            onChange={(e) => setTargetDate(e.target.value)}
          />
        </div>

        <div style={row}>
          <label style={label}>Priority</label>
          <select style={input} value={priority} onChange={(e) => setPriority(e.target.value)}>
            <option value={1}>High (1)</option>
            <option value={2}>Medium (2)</option>
            <option value={3}>Low (3)</option>
          </select>
        </div>

        <div style={row}>
            <label style={label}>Current amount saved ($) <span style={{color:"#888"}}>(optional)</span></label>
            <input
                type="number"
                style={input}
                placeholder="e.g. 8000"
                value={currentAmount}
                onChange={(e) => setCurrentAmount(e.target.value)}
                min="0"
            />
            </div>

        <div style={row}>
          <label style={label}>Notes (optional)</label>
          <textarea
            style={{ ...input, minHeight: 60 }}
            placeholder="Short note"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>

        <div style={{
            background: "#fffdea",
            border: "1px solid #e6d38f",
            borderRadius: 8,
            padding: "10px 12px",
            marginTop: 6,
            marginBottom: 12,
            fontSize: 14,
            color: "#6b5600"
            }}>
            Estimated monthly contribution: <strong>${Number(monthlySuggested).toLocaleString()}</strong>
            <div style={{fontSize:13, marginTop:4}}>
                based on target − current ÷ months until target.
            </div>
            {(Number(currentAmount)||0) >= (Number(targetAmount)||0) && (
                <div style={{fontSize:13, marginTop:6}}>
                ✅ You’re already fully funded for this goal. We’ll set monthly to $0 and mark it as achieved.
                </div>
            )}
            </div>

        <div style={actions}>
          <button onClick={onClose} style={btnGhost}>Cancel</button>
          <button
            onClick={() => {
              if (!name.trim()) return alert("Please enter a goal name.");
              if (!targetAmount || Number(targetAmount) <= 0) return alert("Please enter a positive target amount.");
              if (!targetDate) return alert("Please choose a target date (month).");
              onSave({ name: name.trim(), targetAmount, targetDate, priority, notes, currentAmount });
            }}
            style={btnPrimary}
          >
            Save Goal
          </button>
        </div>
      </div>
    </div>
  );
}

/* ===== helpers & styles ===== */
function defaultYYYYMM(offsetMonths = 12) {
  const d = new Date();
  d.setMonth(d.getMonth() + offsetMonths);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}
function monthsUntil(yyyyMM) {
  if (!yyyyMM) return 12;
  const [y, m] = yyyyMM.split("-").map(Number);
  const now = new Date();
  const target = new Date(isNaN(y) ? now.getFullYear() : y, isNaN(m) ? now.getMonth() : (m - 1), 1);
  return Math.max(1, (target.getFullYear() - now.getFullYear()) * 12 + (target.getMonth() - now.getMonth()));
}

const backdropStyle = {
  position: "fixed", inset: 0, background: "rgba(0,0,0,0.3)", display: "flex",
  alignItems: "center", justifyContent: "center", zIndex: 9999
};
const modalStyle = {
  width: 420, maxWidth: "92vw", background: "#fff", borderRadius: 12, padding: 18,
  boxShadow: "0 8px 24px rgba(0,0,0,0.15)", border: "2px solid #00B074"
};
const headerStyle = {
  margin: 0, marginBottom: 12, background: "#00B074", color: "#fff", padding: "8px 10px",
  borderRadius: 8, fontSize: 18, textAlign: "center"
};
const row = { display: "flex", flexDirection: "column", gap: 6, marginBottom: 10 };
const label = { fontSize: 13, color: "#333" };
const input = { border: "1px solid #ddd", borderRadius: 6, padding: "8px 10px", fontSize: 14 };
const actions = { display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 };
const btnPrimary = {
  background: "#00B074", color: "#fff", border: "none", borderRadius: 6, padding: "8px 12px",
  cursor: "pointer", fontWeight: 600
};
const btnGhost = {
  background: "transparent", color: "#222", border: "1px solid #ccc", borderRadius: 6, padding: "8px 12px",
  cursor: "pointer"
};
